import { Language } from '@/types';

export const translations = {
  ru: {
    auth: {
      loginTitle: 'С возвращением!',
      registerTitle: 'Добро пожаловать!',
      login: 'Войти',
      register: 'Регистрация',
      forgotPassword: 'Забыли пароль?',
      email: 'Email',
      password: 'Пароль',
      name: 'Имя',
      confirmPassword: 'Подтвердите пароль',
      submit: 'Отправить',
      backToLogin: 'Вернуться к входу',
      resetPassword: 'Сбросить пароль',
      socialLogin: 'Войти через',
      or: 'или',
      noAccount: 'Нет аккаунта?',
      haveAccount: 'Уже есть аккаунт?',
      createAccount: 'Создать аккаунт',
      switchLanguage: 'Сменить язык',
      newUser: 'Новый пользователь? Создайте',
      account: 'аккаунт',
      or_continue_with: 'Или зайдите через',
      terms_agreement: 'Вы соглашаетесь с',
      terms_of_use: 'условиями использования',
      and: 'и',
      privacy_policy: 'политикой конфиденциальности',
      loginSuccess: 'Вход выполнен успешно',
      registerSuccess: 'Регистрация выполнена успешно',
      registerEmailSent:
        'На вашу почту отправлена ссылка для подтверждения. Перейдите по ссылке, затем войдите в аккаунт.',
      socialAuthSuccess: 'Вход через социальную сеть выполнен успешно',
      verifyEmailTitle: 'Подтверждение email',
      verifyEmailSuccess: 'Email успешно подтверждён. Теперь вы можете войти.',
      verifyEmailError: 'Некорректная или устаревшая ссылка.',
      verifyEmailNoToken: 'Ссылка для подтверждения не указана.',
      resendVerification: 'Отправить письмо повторно',
      resendVerificationSuccess: 'Если аккаунт существует, письмо отправлено.',
      emailNotVerified: 'Email не подтверждён. Отправить письмо повторно?',
      resendVerificationSent: 'Письмо отправлено. Проверьте почту.',
      forgotPasswordTitle: 'Восстановление пароля',
      forgotPasswordHint:
        'Введите email — мы отправим ссылку для сброса пароля.',
      forgotPasswordSuccess:
        'Если аккаунт существует, ссылка отправлена на email.',
      newPasswordLabel: 'Новый пароль',
      resetPasswordTitle: 'Новый пароль',
      resetPasswordSuccess: 'Пароль успешно обновлён. Войдите с новым паролем.',
      resetPasswordError: 'Некорректная или устаревшая ссылка.',
      resetPasswordNoToken: 'Ссылка для сброса пароля не указана.',
    },
    pages: {
      tree: {
        selectTree: 'Выберите дерево',
      },
      faq: {
        blocks: {
          capsules: {
            title: 'О капсулах',
            items: {
              q1: 'Что такое капсула времени и зачем её создавать?',
              a1: 'Капсула времени — это сообщение, воспоминание или эмоция, сохранённые в цифровом виде для «открытия» в будущем.',
              q2: 'Как работает отправка сообщений в будущее?',
              a2: 'Вы создаёте сообщение, выбираете дату и адресата, мы храним и доставляем его в нужный момент.',
              q3: 'Можно ли пригласить соавторов?',
              a3: 'Да, можно пригласить друзей, семью или коллег и создавать капсулу вместе.',
              q4: 'Что такое «Событие» и как его создать?',
              a4: 'Событие — это момент, которым вы хотите поделиться с близкими. Создайте событие, пригласите соавторов и вместе делитесь мыслями и чувствами.',
              q5: 'Что происходит с капсулами времени после моей смерти?',
              a5: 'Можно заранее создать капсулу, которая будет открыта после вашей смерти или к важной дате. Мы доставим её адресатам согласно вашим указаниям.',
              q6: 'Как увековечить память об ушедшем человеке?',
              a6: 'Создайте капсулу памяти с историями, фото и видео. Можно также посадить дерево в его честь как живой символ памяти.',
            },
          },
          trees: {
            title: 'О деревьях',
            items: {
              q1: 'Можно ли посадить дерево в честь события или человека?',
              a1: 'Да, мы сотрудничаем с эко‑партнёрами и высаживаем деревья, выдаём сертификат и метку на карте.',
              q2: 'Зачем посадка дерева?',
              a2: 'Это связь памяти с будущим: деревья улучшают экологию и становятся живым символом важных моментов.',
            },
          },
          other: {
            title: 'Другое',
            items: {
              q1: 'Насколько безопасно хранение сообщений?',
              a1: 'Используем шифрование и резервное хранение, чтобы обеспечить конфиденциальность и надёжность.',
              q2: 'Как начать пользоваться?',
              a2: 'Зарегистрируйтесь, выберите тип капсулы или события и следуйте шагам мастера.',
            },
          },
        },
      },
    },
    capsuleCreation: {
      activation: {
        title: 'Условия активации',
        manual: 'По кнопке',
        scheduled: 'К определённой дате',
        custodian: 'По указанию доверенного хранителя',
        activate: 'Активировать',
        selectDate: 'Выбрать дату',
        selectedDate: '{{date}}',
        inviteCustodian: 'Пригласить',
        noCustodians: 'Нет доверенных лиц',
        remove: 'Удалить',
      },
      repeat: {
        title: 'График повторов',
        countLabel: 'Количество повторов',
        intervalLabel: 'Интервал',
        infinite: 'Бесконечно',
        popupTitle: 'Настроить интервал',
        apply: 'Применить',
        intervals: {
          year: 'Год',
          month: 'Месяц',
          custom: 'Настроенный',
        },
        mobile: {
          calendar: 'Дата',
          timer: 'Время',
        },
      },
    },
    capsuleReactions: {
      addReaction: 'Поставить реакцию',
      dragAndDrop: 'Потяните и перетащите',
      commentObjectAlt: 'Объект комментария',
      reactionsTitle: 'Медитация',
      emptyState: 'Пока нет реакций',
      reactionAvatarAlt: 'Аватар автора реакции',
      backgroundAlt: 'Фон сценария',
      reactionAlt: 'Изображение реакции',
      selectReaction: 'Выберите реакцию, чтобы увидеть комментарий',
      commentLabel: 'Комментарий',
      closeComment: 'Закрыть',
      back: 'Назад',
      replyLabel: 'Ответ',
      reply: 'Ответить',
      replyAction: 'Отправить ответ',
      noCommentYet: 'Комментарий ещё не оставлен',
      dropHint: 'Перетащите объект на фон',
      anonymous: 'Аноним',
      commentPlaceholder: 'Напишите комментарий...',
      replyPlaceholder: 'Напишите ответ...',
      create: 'Создать',
      changeStone: 'Сменить камень',
      pressToChangeStone: 'Нажмите, чтобы сменить',
      selectStoneLabel: 'Выберите камень',
      selectedStoneAlt: 'Выбранный камень',
      freeStone: 'Бесплатно',
      balanceLabel: 'Баланс',
      purchaseStoneSuccess: 'Камень куплен',
      purchaseStoneError: 'Не удалось купить камень',
      purchaseConfirmText:
        'Вы уверены, что хотите приобрести камень "{{name}}" за "{{price}}"?',
      purchaseConfirm: 'Подтвердить',
      purchaseCancel: 'Отказаться',
    },
    capsuleScenarios: {
      freeLabel: 'Бесплатно',
      previewAlt: 'Предпросмотр сценария:',
      commentObjectAlt: 'Объект комментария сценария:',
      status: {
        available: 'Доступно',
        locked: 'Премиум-сценарий',
      },
      lockedPopup: {
        title: 'Премиум-сценарий',
        description: 'Вам пока недоступен этот сценарий',
        pricePrefix: 'Стоимость:',
        priceSuffix: '$',
        buy: 'Купить доступ',
        close: 'Выбрать позже',
        reactions: {
          balloon: 'Реакции: летящие воздушные шары',
          candle: 'Реакции: горящие свечи',
          flashlight: 'Реакции: светящиеся фонарики',
        },
      },
      balloon: {
        title: 'Воздушные шары',
        description:
          'Романтичный праздник под открытым небом. Свет, шарики и лёгкость встречи.',
        previewComment: {
          author: 'Мария',
          text: 'Люблю этот момент!',
          date: '16.01, 15:00',
        },
      },
      candle: {
        title: 'Свечи',
        description:
          'Уютный вечер в окружении друзей. Мягкое сияние и воспоминания у камина.',
        previewComment: {
          author: 'Анна',
          text: 'Свечи делают каждый вечер особенным.',
          date: '03.12, 19:02',
        },
      },
      flashlight: {
        title: 'Фонарики',
        description:
          'Тёплые огни ночного города. Сценарий для ярких признаний и импровизаций.',
        previewComment: {
          author: 'Алексей',
          text: 'Самая волшебная прогулка под огнями города.',
          date: '12.09, 22:48',
        },
      },
      pebble: {
        title: 'Галька у моря',
        description:
          'Звуки прибоя и следы на песке. Идеально для воспоминаний о путешествиях.',
        previewComment: {
          author: 'Екатерина',
          text: 'Помните, как мы собирали камешки на закате?',
          date: '21.06, 20:15',
        },
      },
    },
    inviteCoauthors: {
      title: 'Определить круг доверенных лиц',
      custodianHint:
        'Доверенного хранителя можно пригласить если вы взаимоподписаны друг на друга',
      searchPlaceholder: 'Введите имя или почту',
      searchMatches: 'Совпадения по запросу',
      emailPlaceholder: 'Электронная почта',
      sendInvite: 'Отправить',
      invite: 'Пригласить',
      noResults: 'Мы никого не нашли',
      copyLink: 'Копировать ссылку',
      error: 'Не удалось отправить приглашение',
    },
    activationPopup: {
      title: 'Активация',
      dateTitle: 'Выберите дату',
      timeTitle: 'Выберите время',
      dateTab: 'Дата',
      timeTab: 'Время',
      apply: 'Применить',
    },
    validation: {
      emailRequired: 'Email обязателен',
      emailInvalid: 'Введите корректный email',
      passwordRequired: 'Пароль обязателен',
      passwordMinLength: 'Пароль должен состоять не меньше, чем 8 символов',
      passwordMismatch: 'Пароли не совпадают',
      confirmPasswordRequired: 'Подтвердите пароль',
    },
    common: {
      pageNotFound: 'Страница не найдена',
      loading: 'Загрузка...',
      content: 'Контент',
      reactions: 'Медитация',
      close: 'Закрыть',
      save: 'Сохранить',
      cancel: 'Отменить',
      back: 'Назад',
      more: 'Ещё',
      collapse: 'Свернуть',
      timeUnits: {
        years: 'Годы',
        months: 'Месяцы',
        days: 'Дни',
        hours: 'Часы',
        minutes: 'Минуты',
      },
      timeCounter: {
        increase: 'Увеличить',
        decrease: 'Уменьшить',
      },
    },
    chat: {
      page: {
        selectConversation: 'Выберите диалог или начните новый',
      },
      list: {
        title: 'Чаты',
        searchPlaceholder: 'Поиск по чатам',
        loading: 'Загружаем чаты...',
        empty: 'Пока нет ни одного чата',
        nothingFound: 'Ничего не найдено',
        noMessages: 'Нет сообщений',
        untitled: 'Без названия',
        capsuleAttachment: 'Капсула',
        ownPrefix: 'Вы: {text}',
      },
      thread: {
        loading: 'Загружаем переписку...',
        empty: 'Сообщений пока нет. Напишите первым!',
        today: 'Сегодня',
        yesterday: 'Вчера',
      },
      composer: {
        placeholder: 'Напишите сообщение, «/» — вставить капсулу',
        capsuleHint: 'Ваши капсулы',
        searching: 'Ищем капсулы...',
        noCapsules: 'Капсулы не найдены',
        removeAttachment: 'Убрать капсулу',
      },
      message: {
        capsuleUnavailable: 'Капсула недоступна',
        sending: 'Отправляется...',
        retry: 'Не отправлено. Повторить',
      },
      new: {
        title: 'Новый чат',
        groupTitle: 'Новая группа',
        tabDirect: 'Личный чат',
        tabGroup: 'Группа',
        searchPlaceholder: 'Имя пользователя',
        searchHint: 'Найдите собеседника по имени пользователя',
        searching: 'Ищем...',
        nothingFound: 'Пользователи не найдены',
        groupNamePlaceholder: 'Название группы',
        createGroup: 'Создать группу',
      },
      details: {
        title: 'О чате',
        members: 'Участники',
        membersSuffix: 'участников',
        addMembers: 'Добавить участников',
        inviteLink: 'Ссылка-приглашение',
        inviteLinkHint: 'Нажмите «Скопировать», чтобы получить ссылку',
        copyLink: 'Скопировать',
        linkCopied: 'Скопировано',
        removeMember: 'Удалить участника',
        leaveGroup: 'Покинуть группу',
        openProfile: 'Открыть профиль',
        role: {
          owner: 'Создатель',
          admin: 'Админ',
        },
      },
      invite: {
        loading: 'Загружаем приглашение...',
        invalid: 'Ссылка-приглашение недействительна',
        join: 'Вступить в чат',
        open: 'Открыть чат',
        invitedBy: 'приглашает',
      },
      system: {
        someone: 'Кто-то',
        groupCreated: '{actor} создал(а) группу «{title}»',
        membersAdded: '{actor} добавил(а) в чат: {users}',
        memberJoined: '{actor} присоединился(-ась) по ссылке',
        memberRemoved: '{actor} удалил(а) из чата: {users}',
        memberLeft: '{actor} покинул(а) чат',
        groupRenamed: '{actor} переименовал(а) чат в «{to}»',
      },
      mediator: {
        name: 'Медиатор',
        sectionTitle: 'Медиатор',
        sectionHint:
          'Помогает не теряться: зовёт в разговор, напоминает о датах, спрашивает, как дела.',
        on: 'Включён',
        off: 'Выключен',
        toggleError: 'Не удалось изменить настройку медиатора',
      },
      errors: {
        conversationsLoad: 'Не удалось загрузить чаты',
        messagesLoad: 'Не удалось загрузить сообщения',
        conversationCreate: 'Не удалось создать чат',
        memberAdd: 'Не удалось добавить участника',
        memberRemove: 'Не удалось удалить участника',
        inviteLink: 'Не удалось получить ссылку',
      },
    },
    header: {
      home: 'Главная',
      about: 'О нас',
      faq: 'FAQ',
      capsules: 'Капсулы',
      chat: 'Чаты',
      notifications: 'Уведомления',
      profile: 'Профиль',
      create: 'Создать',
      search: 'Найдите в своих капсулах...',
      toMyCapsules: 'К моим капсулам',
      growTree: 'Посадить дерево',
      preview: 'Превью',
      exitPreview: 'Выйти из превью',
      activateCapsule: 'Активировать капсулу',
      upload: 'Загрузить',
      created: 'Создана',
      firstOpened: 'Впервые открыта',
      selectTree: 'Выберите дерево',
      menu: 'Меню',
      searchUsers: 'Пользователи',
      searchCapsules: 'Капсулы',
      searchLoading: 'Поиск...',
      searchEmpty: 'Ничего не найдено',
    },
    capsuleCreate: {
      tabs: {
        settings: 'Шаг 1 →',
        content: 'Шаг 2 →',
        scenarios: 'Шаг 3',
      },
      titleLabel: 'Название капсулы',
      descriptionLabel: 'Чем вы хотите поделиться сегодня?',
      draftTitle: 'Без названия',
      authorName: 'Вы',
      coauthors: {
        title: 'Соавторы',
        noCoauthors: 'У вас пока нет соавторов',
        invite: 'Пригласить',
        loading: 'Загрузка...',
        reinvite: 'Отправить повторно',
        remove: 'Удалить',
        status: {
          pending: 'Отправлено',
          accepted: 'Принято',
          declined: 'Отклонено',
        },
      },
      viewers: {
        title: 'Кто может видеть капсулу?',
        all: 'Все',
        coauthors: 'Только соавторы',
        selected: 'Выбранный круг лиц',
        invite: 'Выбрать',
        remove: 'Удалить',
      },
      contentEmpty: 'У вас ещё нет контента, загрузите его',
      contentUpload: {
        title: 'Загрузите ваши медиа файлы',
        cancel: 'Отменить',
        clearAll: 'Очистить все',
        save: 'Сохранить',
        backToUpload: 'Вернуться к загрузке',
        viewMedia: 'Просмотр медиа',
        description: 'Описание',
        deleteDescription: 'Удалить описание',
        replaceMedia: 'Заменить медиа',
        filePreview: 'Предпросмотр файла',
        videoPreview: 'Предпросмотр видео',
        gifPreview: 'Предпросмотр GIF',
        maxFilesReached: 'Максимум файлов: {{max}}. Достигнут лимит файлов.',
        maxFilesPartial:
          'Максимум файлов: {{max}}. Загружено только {{loaded}} из {{total}} файлов.',
        video: 'VIDEO',
        gif: 'GIF',
        dragAndDrop: 'Загрузите или перетащите файлы',
        fileFormats: 'JPG, JPEG, PNG, GIF, MP3, MP4, MOV, WEBP. Max 20 MB',
        livePhotoNote:
          'Live Фото с IPhone будут автоматически конвертированы в GIF',
        fileTooLarge:
          'Файл "{{fileName}}" слишком большой ({{size}} MB). Максимальный размер: {{maxSize}} MB',
        unsupportedFormat:
          'Файл "{{fileName}}" имеет неподдерживаемый формат. Разрешены: {{formats}}',
        allowedFormats: 'JPG, JPEG, PNG, GIF, WEBP, MP3, MP4, MOV',
        uploadErrors: 'Ошибки загрузки файлов:',
        filesUploadedSuccess: 'Успешно загружено файлов: {{count}}',
      },
    },
    capsulePost: {
      dateNotSpecified: 'Дата не указана',
      unknownAuthor: 'Неизвестный автор',
      titleUnavailable: 'Заголовок недоступен',
      contentUnavailable: 'Содержимое недоступно',
      donate: 'Внести вклад',
      plantTree: 'Посадить дерево',
      expand: 'далее',
      collapse: 'свернуть',
    },
    capsuleCreators: {
      you: 'Вы',
      youAndCoauthors: 'Вы и {count} {coauthor}',
      ownerAndCoauthors: '{owner} и {count} {coauthor}',
      coauthorsOnly: '{count} {coauthor}',
      coauthorOne: 'соавтор',
      coauthorFew: 'соавтора',
      coauthorMany: 'соавторов',
    },
    capsulePostActions: {
      delete: 'Удалить',
      copyLink: 'Копировать ссылку',
    },
    myCapsules: {
      title: 'Мои капсулы',
      closed: 'Закрытые',
      opened: 'Открытые',
      activate: 'Активировать',
      noCapsules: 'Капсул пока нет',
      notifications: {
        activateSuccess: 'Капсула успешно активирована',
        activateError: 'Не удалось активировать капсулу',
        publishSuccess: 'Подтверждение публикации принято',
        publishError: 'Не удалось опубликовать капсулу жизни',
        createSuccess: 'Капсула успешно создана',
        createError: 'Не удалось сохранить капсулу',
        deleteSuccess: 'Капсула удалена',
      },
    },
    feed: {
      emptyCapsules: 'Капсул пока нет',
    },
    capsulesEmptyState: {
      createButton: 'Создать капсулу',
    },
    footer: {
      menuTitles: {
        menu: 'Меню',
        contacts: 'Контакты',
        weWillContactYou: 'Мы свяжемся с вами',
      },
      menuItems: {
        about: 'О нас',
        faq: 'FAQ',
        notifications: 'Уведомления',
        profile: 'Профиль',
        feed: 'Главная (Лента)',
        myCapsules: 'Мои капсулы',
      },
      interactiveMenuItems: {
        select: {
          wantToCollaborate: 'Хочу сотрудничать',
          wantToBePartner: 'Хочу стать партнёром',
          feedbackOrIdea: 'Отзыв или идея',
          commercialProposal: 'Коммерческое предложение',
          mediaPublication: 'Публикация в СМИ',
          other: 'Другое',
        },
        input: {
          yourEmail: 'Ваша почта',
        },
        button: {
          send: 'Отправить',
        },
      },
      links: {
        privacyPolicy: 'Политика конфиденциальности',
        termsOfUse: 'Пользовательское соглашение',
      },
    },
    profileMenu: {
      metrics: {
        followers: 'подписчиков',
        following: 'подписок',
        coauthors: 'соавторов',
      },
      tabs: {
        profile: 'Профиль',
        security: 'Безопасность',
        privacy: 'Конфиденциальность',
        notifications: 'Уведомления',
        billing: 'Подписка',
        wallet: 'Кошелек',
      },
      logout: 'Выйти',
    },
    profileTab: {
      username: 'Имя пользователя',
      usernamePlaceholder: 'Имя пользователя',
      firstName: 'Имя',
      middleName: 'Отчество',
      lastName: 'Фамилия',
      bio: 'Описание',
      personalInfo: 'Личная информация',
      gender: 'Пол',
      genderNotSelected: 'Не выбран',
      male: 'Мужской',
      female: 'Женский',
      birthday: 'День рождения',
      datePlaceholder: 'ДД.ММ.ГГГГ',
      birthPlace: 'Место рождения',
      residencePlace: 'Место проживания',
      country: 'Страна',
      city: 'Город',
      postalCode: 'Почтовый индекс',
      socials: 'Соцсети',
      mediatorSummary: 'Что медиатор знает обо мне',
      mediatorSummaryEmpty:
        'Пока пусто. Карточка появится, когда вы напишете несколько сообщений в групповом чате.',
      cancelChanges: 'Отменить изменения',
    },
    profileSecurity: {
      phone: 'Номер телефона',
      email: 'Почта',
      password: 'Пароль',
      change: 'Сменить',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      changePasswordTitle: 'Смена пароля',
      changePasswordSuccess: 'Пароль успешно изменён.',
      changePasswordError: 'Не удалось изменить пароль.',
      changePasswordWrong: 'Текущий пароль указан неверно.',
      cancel: 'Отмена',
      save: 'Сохранить',
    },
    profilePrivacy: {
      title: 'Показывать аватар и имя в комментариях',
      all: 'Все',
      coauthors: 'Только соавторы',
      selected: 'Только выбранные люди',
      noSelectedUsers: 'У вас пока нет избранных пользователей',
      invite: 'Пригласить',
      emailDuplicatesEnabled: 'Разрешить дублирование email-уведомлений',
    },
    profileNotifications: {
      title: 'Уведомления',
      unread: 'Непрочитанные',
      read: 'Прочитанные',
      all: 'Все',
      emptyUnread: 'У вас не осталось непрочитанных уведомлений',
      emptyRead: 'У вас нет прочитанных уведомлений',
      emptyAll: 'У вас пока нет уведомлений',
      messages: {
        invite: '{inviterName} приглашает вас в капсулу «{capsuleName}»',
        custodian_invite: 'Вас назначили хранителем капсулы «{capsuleName}»',
        custodian_activated: 'Хранитель активировал капсулу «{capsuleName}»',
        capsule_opened: 'Капсула «{capsuleName}» открылась',
        coauthor_declined:
          '{declinerName} отказался быть соавтором в капсуле «{capsuleName}»',
        death_report:
          '{reporterName} подал запрос на публикацию капсулы жизни «{capsuleName}». Если это ошибка — отмените запрос.',
        donation:
          '{donorName} внёс вклад в размере {amount} $ в высадку «{treeName}» для вашей капсулы «{capsuleName}»',
        fundraising_started:
          'Для вашей капсулы «{capsuleName}» {initiatorName} открыл сбор средств на высадку «{treeName}»',
        fundraising_completed:
          'Для вашей капсулы «{capsuleName}» собраны средства для высадки «{treeName}»',
        reaction: '{reactorName} оставил реакцию в капсуле «{capsuleName}»',
        invite_response_accepted:
          '{actorName} принял(а) приглашение в капсулу «{capsuleName}»',
        invite_response_declined:
          '{actorName} отклонил(а) приглашение в капсулу «{capsuleName}»',
      },
      actions: {
        accept: 'Принять',
        decline: 'Отклонить',
        reinvite: 'Пригласить повторно',
        read: 'Прочитать',
        cancel: 'Отменить',
        cancelDeathReport: 'Отменить запрос',
      },
      activatedAt: 'Активирована: ',
      timeLeft: 'Осталось:',
      countdownDaysShort: 'д',
      reinviteSuccess: 'Повторное приглашение отправлено',
    },
    profileBilling: {
      title: 'Подписка PRO',
      pricePromo: '100 $/мес.',
      includes: 'Что входит в подписку',
      benefits: {
        unlimitedCapsules: 'Неограниченное количество капсул',
        comments: 'Возможность оставлять комментарии',
        giftReactions: '5 платных реакций в подарок',
      },
      price: '200 $/мес',
      nextPaymentPrefix: 'Ваш следующий платёж будет осуществлён',
      subscribe: 'Оформить',
      unsubscribe: 'Отписаться',
    },
    socialInput: {
      placeholder: 'Вставьте ссылку на аккаунт',
    },
    userProfile: {
      filter: {
        author: 'Автор',
        coauthor: 'Соавтор',
      },
      noCapsules: 'У пользователя пока нет капсул',
    },
    userProfileCard: {
      notSpecified: 'Не указано',
      copyId: 'Скопировать ID',
      metrics: {
        followers: 'подписчиков',
        following: 'подписок',
        coauthors: 'соавторов',
      },
      follow: 'Подписаться',
      unfollow: 'Отписаться',
    },
    aboutPage: {
      section01: {
        text: 'Мы верим, что жизнь прекрасна, сложна и хрупка. TimeCaps объединяет всё, что помогает поддерживать связь сквозь время и расстояния.',
      },
      section02: {
        text1:
          'Понимая, как важно не упустить момент, мы создали простые и бережные инструменты для сохранения вашей личной и семейной истории.',
        text2:
          '# 1. Общение и поддержка\n## Оставайтесь ближе к тем, кто вам дорог. Даже когда на обычный звонок не хватает времени.\nУ каждого из нас есть люди, с которыми хочется общаться чаще. Позвонить родителям или пожилым родственникам, узнать, как прошла неделя у друга, поговорить с человеком, который живёт один. Но в бесконечном потоке работы, дел и забот мы часто откладываем эти разговоры — не потому, что они нам не важны, а потому, что всё время кажется: «позвоню чуть позже».\nНаш проект помогает сделать общение регулярной и естественной частью жизни.\nСоздайте чат с одним человеком или небольшой компанией — с родными, друзьями или знакомыми, которым особенно важно внимание и живое общение. А наш медиатор поможет разговору начаться и продолжаться: предложит интересную тему, задаст вопрос, поддержит беседу и мягко вовлечёт всех участников.\nМедиатор может поддержать беседу самостоятельно, задавать вопросы, выслушивать истории и просто быть внимательным собеседником, даже если у вас не получилось вступить в диалог. Для одинокого пожилого человека даже такой разговор может стать приятным моментом дня — возможностью почувствовать внимание, интерес к своей жизни и то, что рядом есть тот, кто готов его выслушать.\nПотому что иногда человеку нужно совсем немного: чтобы его спросили, как он, выслушали его историю и просто побыли с ним в одном разговоре.',
      },
      section03: {
        text: '# 2. Капсула времени: письмо близкому человеку\n## Сохраните самое важное для тех, кто вам дорог\nВ ежедневной суете нам часто не хватает момента, чтобы сказать главным людям в жизни самые тёплые и нужные слова. Капсула времени — это возможность бережно запечатлеть то, что давно живёт в вашем сердце: слова любви, благодарности, признания или важные воспоминания.\nВы можете поделиться ими уже сегодня или доверить сервису передать ваше послание в определённый день в будущем — когда близким будет особенно важно почувствовать вашу поддержку и тепло.',
        displayText:
          'Эти цифровые капсулы времени — не просто файлы или публикации. Это искренние письма, видео, фотографии и мысли — наполненные любовью и сохранённые для будущего.',
      },
      section04: {
        text: '# 3. Забота о старшем поколении\n## Помогите родным сохранить их историю\nУ каждого поколения есть своя мудрость, семейные истории и воспоминания, которые так важно сохранить. Помогите вашим родителям, бабушкам, дедушкам или старшим близким записать их мысли и послания.\nМы сделали процесс максимально простым и интуитивным: вы можете вместе заполнить их первую «капсулу времени», расспросить о том, на что раньше не хватало времени, и научить их этому светлому способу оставлять след в памяти семьи.',
      },
      section05: {
        text1:
          '# 4. Общая память: коллективные воспоминания\n## Делитесь важным в общем пространстве\nУ каждого из нас есть события и люди, оставшиеся искрой в душе. Поделитесь своими чувствами, историями и воспоминаниями в нашей коллективной медитации.\nЭто пространство тепла и памяти, где искренние истории объединяют людей, помогают прожить важные эмоции и почувствовать, что мы не одни.',
        text2:
          'Мы здесь, чтобы помочь вам сохранить то, что действительно важно. Поделиться своими чувствами, эмоциями, переживаниями.',
        text3: 'Присоединяйтесь к нам.',
      },
      section06: {
        title:
          'Давайте вместе праздновать жизнь, ценить прошлое и оставлять после себя нечто по-настоящему значимое!',
        button: 'Создать капсулу',
      },
    },
    payment: {
      title: {
        treeDonation: 'Высадка дерева',
        subscription: 'Оформление подписки',
        scenarioPurchase: 'Покупка сценария',
      },
      card: {
        attachCard: 'Привяжите карту',
      },
      cardInput: {
        numberPlaceholder: '0000 0000 0000 0000',
        namePlaceholder: 'NAME SURNAME',
        expiryPlaceholder: 'ММ/ГГ',
        cvvPlaceholder: 'CVV',
      },
      subscribePlan: {
        choosePlan: 'Выберите свой план',
        yearPlan: 'Годовая подписка',
        monthPlan: 'Месячная подписка',
        preliminaryTotal: 'Предварительный итог',
        discount: 'Скидка',
        total: 'Итог',
        priceSuffix: '$/мес',
      },
      scenarioPurchase: {
        purchaseScenario: 'Оплатите сценарий',
      },
      actions: {
        agreePrefix: 'Я соглашаюсь с',
        terms: 'условиями',
        brand: 'TimeCaps',
        pay: 'Оплатить',
        processing: 'Обработка...',
      },
      operationInfo: {
        remaining: 'Осталось',
        requestId: 'ID заявки',
      },
      treeDonate: {
        enterAmountTitle: 'Введите сумму платежа',
        rangeLabel: 'От 1 $',
        amountLabel: 'Сумма платежа',
      },
      wallet: {
        enterAmountTitle: 'Пополнить баланс',
        rangeLabel: 'От 1 $',
        amountLabel: 'Сумма пополнения',
        invalidAmount: 'Сумма должна быть от 1 $',
        created: 'Платёж создан. Переходим к оплате.',
        error: 'Ошибка при создании пополнения',
      },
      progressBilling: {
        people: 'человек',
        collected: 'Собрано',
      },
    },
  },
  en: {
    auth: {
      loginTitle: 'Welcome back!',
      registerTitle: 'Welcome!',
      login: 'Login',
      register: 'Register',
      forgotPassword: 'Forgot password?',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      submit: 'Submit',
      backToLogin: 'Back to login',
      resetPassword: 'Reset password',
      socialLogin: 'Login with',
      or: 'or',
      noAccount: "Don't have an account?",
      haveAccount: 'Already have an account?',
      createAccount: 'Create account',
      switchLanguage: 'Switch language',
      newUser: 'New user? Create an',
      account: 'account',
      or_continue_with: 'Or continue with',
      terms_agreement: 'You agree to the',
      terms_of_use: 'Terms of Use',
      and: 'and',
      privacy_policy: 'Privacy Policy',
      loginSuccess: 'Login successful',
      registerSuccess: 'Registration successful',
      registerEmailSent:
        'A confirmation link has been sent to your email. Click the link, then sign in.',
      socialAuthSuccess: 'Social login successful',
      verifyEmailTitle: 'Verify email',
      verifyEmailSuccess: 'Email verified. You can sign in now.',
      verifyEmailError: 'Invalid or expired link.',
      verifyEmailNoToken: 'Verification link not provided.',
      resendVerification: 'Resend verification email',
      resendVerificationSuccess:
        'If the account exists, an email has been sent.',
      emailNotVerified: 'Email not verified. Resend verification email?',
      resendVerificationSent: 'Email sent. Check your inbox.',
      forgotPasswordTitle: 'Reset password',
      forgotPasswordHint: 'Enter your email and we’ll send a reset link.',
      forgotPasswordSuccess:
        'If the account exists, a reset link has been sent.',
      newPasswordLabel: 'New password',
      resetPasswordTitle: 'New password',
      resetPasswordSuccess: 'Password updated. Sign in with your new password.',
      resetPasswordError: 'Invalid or expired link.',
      resetPasswordNoToken: 'Reset link not provided.',
    },
    pages: {
      tree: {
        selectTree: 'Select tree',
      },
      faq: {
        blocks: {
          capsules: {
            title: 'About capsules',
            items: {
              q1: 'What is a time capsule and why create it?',
              a1: 'A time capsule is a message, memory or emotion saved digitally to be opened in the future.',
              q2: 'How does sending to the future work?',
              a2: 'Create a message, choose the date and recipient; we store and deliver it at the right time.',
              q3: 'Can I invite co-authors?',
              a3: 'Yes, invite friends, family or colleagues to create a capsule together.',
              q4: 'What is an «Event» and how to create it?',
              a4: 'An Event is a moment to share with close ones. Create it, invite co-authors and share thoughts and feelings together.',
              q5: 'What happens to capsules after my death?',
              a5: 'You can prepare a capsule to be opened after your death or on a specific date. We will deliver it according to your instructions.',
              q6: 'How to commemorate a deceased person?',
              a6: 'Create a memory capsule with stories, photos and videos. You can also plant a tree as a living tribute.',
            },
          },
          trees: {
            title: 'About trees',
            items: {
              q1: 'Can I plant a tree for an event or a person?',
              a1: 'Yes. We partner with eco projects, plant trees, provide a certificate and a map location.',
              q2: 'Why planting a tree?',
              a2: 'It connects memory with the future: trees improve ecology and become a living symbol.',
            },
          },
          other: {
            title: 'Other',
            items: {
              q1: 'How secure is message storage?',
              a1: 'We use encryption and backups to ensure confidentiality and durability.',
              q2: 'How do I get started?',
              a2: 'Sign up, choose a capsule or event type and follow the setup steps.',
            },
          },
        },
      },
    },
    capsuleCreation: {
      activation: {
        title: 'Activation settings',
        manual: 'Manual trigger',
        scheduled: 'On a specific date',
        custodian: 'By trusted keeper instruction',
        activate: 'Activate',
        selectDate: 'Pick date',
        selectedDate: '{{date}}',
        inviteCustodian: 'Invite',
        noCustodians: 'No trusted persons',
        remove: 'Remove',
      },
      repeat: {
        title: 'Repeat schedule',
        countLabel: 'Number of repeats',
        intervalLabel: 'Interval',
        infinite: 'Infinite',
        popupTitle: 'Configure interval',
        apply: 'Apply',
        intervals: {
          year: 'Year',
          month: 'Month',
          custom: 'Custom',
        },
      },
    },
    capsuleReactions: {
      addReaction: 'Add reaction',
      dragAndDrop: 'Drag and drop',
      commentObjectAlt: 'Comment object',
      reactionsTitle: 'Meditation',
      emptyState: 'No reactions yet',
      reactionAvatarAlt: 'Reaction author avatar',
      backgroundAlt: 'Scenario background',
      reactionAlt: 'Reaction preview',
      selectReaction: 'Select a reaction to see the comment',
      commentLabel: 'Comment',
      closeComment: 'Close',
      back: 'Back',
      replyLabel: 'Reply',
      reply: 'Reply',
      replyAction: 'Send reply',
      noCommentYet: 'No comment yet',
      dropHint: 'Drop the object onto the scene',
      anonymous: 'Anonymous',
      commentPlaceholder: 'Write a comment...',
      replyPlaceholder: 'Write a reply...',
      create: 'Create',
      changeStone: 'Change stone',
      pressToChangeStone: 'Click to change',
      selectStoneLabel: 'Select a stone',
      selectedStoneAlt: 'Selected stone',
      freeStone: 'Free',
      balanceLabel: 'Balance',
      purchaseStoneSuccess: 'Stone purchased',
      purchaseStoneError: 'Failed to purchase stone',
      purchaseConfirmText:
        'Are you sure you want to purchase the stone "{{name}}" for "{{price}}"?',
      purchaseConfirm: 'Confirm',
      purchaseCancel: 'Cancel',
    },
    capsuleScenarios: {
      freeLabel: 'Free',
      previewAlt: 'Scenario preview:',
      commentObjectAlt: 'Scenario comment object:',
      status: {
        available: 'Available',
        locked: 'Premium scenario',
      },
      lockedPopup: {
        title: 'Premium scenario',
        description: 'This scenario is not available to you yet',
        pricePrefix: 'Price:',
        priceSuffix: '$',
        buy: 'Buy access',
        close: 'Maybe later',
        reactions: {
          balloon: 'Reactions: flying balloons',
          candle: 'Reactions: burning candles',
          flashlight: 'Reactions: glowing flashlights',
        },
      },
      balloon: {
        title: 'Balloons',
        description:
          'A romantic celebration in the open air. Lights, balloons, and a weightless mood.',
        previewComment: {
          author: 'Maria',
          text: 'I love this moment!',
          date: '16.01, 15:00',
        },
      },
      candle: {
        title: 'Candles',
        description:
          'A cosy evening with friends. Warm glow and stories shared by the fireplace.',
        previewComment: {
          author: 'Anna',
          text: 'Candles make every evening special.',
          date: '03.12, 19:02',
        },
      },
      flashlight: {
        title: 'Flashlights',
        description:
          'The warm lights of the night city. Perfect for bright confessions and improvisations.',
        previewComment: {
          author: 'Alexey',
          text: 'The most magical walk under the city lights.',
          date: '12.09, 22:48',
        },
      },
      pebble: {
        title: 'Seaside Pebbles',
        description:
          'Waves rolling in and footsteps on the sand. Ideal for memories of travel.',
        previewComment: {
          author: 'Katherine',
          text: 'Remember how we collected pebbles at sunset?',
          date: '21.06, 20:15',
        },
      },
    },
    inviteCoauthors: {
      title: 'Define your circle of trusted people',
      custodianHint:
        'You can invite a trusted keeper only if you follow each other',
      searchPlaceholder: 'Type name or email',
      searchMatches: 'Matches for your query',
      emailPlaceholder: 'Email',
      sendInvite: 'Send invite',
      invite: 'Invite',
      noResults: 'No matches found',
      hint: 'Start typing to see suggestions',
      copyLink: 'Copy link',
      error: 'Could not send the invitation. Check your input and try again.',
    },
    activationPopup: {
      title: 'Activation',
      dateTitle: 'Select date',
      timeTitle: 'Select time',
      dateTab: 'Date',
      timeTab: 'Time',
      apply: 'Apply',
    },
    validation: {
      emailRequired: 'Email is required',
      emailInvalid: 'Please enter a valid email',
      passwordRequired: 'Password is required',
      passwordMinLength: 'Password must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
      confirmPasswordRequired: 'Please confirm your password',
    },
    errors: {
      invalidCredentials: 'Invalid email or password',
      userNotFound: 'User not found',
      emailAlreadyExists: 'User with this email already exists',
      networkError: 'Network error. Please try again later',
      unknownError: 'An unknown error occurred',
    },
    common: {
      pageNotFound: 'Page not found',
      loading: 'Loading...',
      content: 'Content',
      reactions: 'Meditation',
      close: 'Close',
      save: 'Save',
      cancel: 'Cancel',
      back: 'Back',
      more: 'More',
      collapse: 'Collapse',
      timeUnits: {
        years: 'Years',
        months: 'Months',
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
      },
      timeCounter: {
        increase: 'Increase',
        decrease: 'Decrease',
      },
    },
    chat: {
      page: {
        selectConversation: 'Select a chat or start a new one',
      },
      list: {
        title: 'Chats',
        searchPlaceholder: 'Search chats',
        loading: 'Loading chats...',
        empty: 'No chats yet',
        nothingFound: 'Nothing found',
        noMessages: 'No messages',
        untitled: 'Untitled',
        capsuleAttachment: 'Capsule',
        ownPrefix: 'You: {text}',
      },
      thread: {
        loading: 'Loading conversation...',
        empty: 'No messages yet. Say hello!',
        today: 'Today',
        yesterday: 'Yesterday',
      },
      composer: {
        placeholder: 'Write a message, press "/" to attach a capsule',
        capsuleHint: 'Your capsules',
        searching: 'Searching capsules...',
        noCapsules: 'No capsules found',
        removeAttachment: 'Remove capsule',
      },
      message: {
        capsuleUnavailable: 'Capsule unavailable',
        sending: 'Sending...',
        retry: 'Not sent. Retry',
      },
      new: {
        title: 'New chat',
        groupTitle: 'New group',
        tabDirect: 'Direct chat',
        tabGroup: 'Group',
        searchPlaceholder: 'Username',
        searchHint: 'Find someone by their username',
        searching: 'Searching...',
        nothingFound: 'No users found',
        groupNamePlaceholder: 'Group name',
        createGroup: 'Create group',
      },
      details: {
        title: 'Chat info',
        members: 'Members',
        membersSuffix: 'members',
        addMembers: 'Add members',
        inviteLink: 'Invite link',
        inviteLinkHint: 'Press "Copy" to get the link',
        copyLink: 'Copy',
        linkCopied: 'Copied',
        removeMember: 'Remove member',
        leaveGroup: 'Leave group',
        openProfile: 'Open profile',
        role: {
          owner: 'Owner',
          admin: 'Admin',
        },
      },
      invite: {
        loading: 'Loading invite...',
        invalid: 'This invite link is no longer valid',
        join: 'Join chat',
        open: 'Open chat',
        invitedBy: 'invited by',
      },
      system: {
        someone: 'Someone',
        groupCreated: '{actor} created the group "{title}"',
        membersAdded: '{actor} added {users}',
        memberJoined: '{actor} joined via invite link',
        memberRemoved: '{actor} removed {users}',
        memberLeft: '{actor} left the chat',
        groupRenamed: '{actor} renamed the chat to "{to}"',
      },
      mediator: {
        name: 'Mediator',
        sectionTitle: 'Mediator',
        sectionHint:
          'Helps people stay in touch: invites them into conversations, reminds about dates, asks how they are.',
        on: 'On',
        off: 'Off',
        toggleError: 'Could not change the mediator setting',
      },
      errors: {
        conversationsLoad: 'Could not load chats',
        messagesLoad: 'Could not load messages',
        conversationCreate: 'Could not create the chat',
        memberAdd: 'Could not add the member',
        memberRemove: 'Could not remove the member',
        inviteLink: 'Could not get the invite link',
      },
    },
    header: {
      home: 'Home',
      about: 'About',
      faq: 'FAQ',
      capsules: 'Capsules',
      chat: 'Chats',
      notifications: 'Notifications',
      profile: 'Profile',
      create: 'Create',
      search: 'Find in your capsules...',
      toMyCapsules: 'To my capsules',
      growTree: 'Plant a tree',
      preview: 'Preview',
      exitPreview: 'Exit preview',
      activateCapsule: 'Activate capsule',
      upload: 'Upload',
      created: 'Created',
      firstOpened: 'First opened',
      selectTree: 'Select tree',
      menu: 'Menu',
      searchUsers: 'Users',
      searchCapsules: 'Capsules',
      searchLoading: 'Searching...',
      searchEmpty: 'Nothing found',
    },
    capsuleCreate: {
      tabs: {
        settings: 'Step 1 →',
        content: 'Step 2 →',
        scenarios: 'Step 3',
      },
      titleLabel: 'Capsule title',
      descriptionLabel: 'What do you want to share today?',
      draftTitle: 'Untitled',
      authorName: 'You',
      coauthors: {
        title: 'Co-authors',
        noCoauthors: 'You have no co-authors yet',
        invite: 'Invite',
        loading: 'Loading...',
        reinvite: 'Resend',
        remove: 'Remove',
        status: {
          pending: 'Sent',
          accepted: 'Accepted',
          declined: 'Declined',
        },
      },
      viewers: {
        title: 'Who can see the capsule?',
        all: 'All',
        coauthors: 'Only co-authors',
        selected: 'Only selected people',
        invite: 'Select',
      },
      contentEmpty: 'You have no content yet, upload it',
      contentUpload: {
        title: 'Upload your media files',
        cancel: 'Cancel',
        clearAll: 'Clear all',
        save: 'Save',
        backToUpload: 'Back to upload',
        viewMedia: 'View media',
        description: 'Description',
        deleteDescription: 'Delete description',
        replaceMedia: 'Replace media',
        filePreview: 'File preview',
        videoPreview: 'Video preview',
        gifPreview: 'GIF preview',
        maxFilesReached: 'Maximum files: {{max}}. File limit reached.',
        maxFilesPartial:
          'Maximum files: {{max}}. Only {{loaded}} of {{total}} files uploaded.',
        video: 'VIDEO',
        gif: 'GIF',
        dragAndDrop: 'Upload or drag and drop files',
        fileFormats: 'JPG, JPEG, PNG, GIF, MP3, MP4, MOV, WEBP. Max 20 MB',
        livePhotoNote:
          'Live Photos from iPhone will be automatically converted to GIF',
        fileTooLarge:
          'File "{{fileName}}" is too large ({{size}} MB). Maximum size: {{maxSize}} MB',
        unsupportedFormat:
          'File "{{fileName}}" has an unsupported format. Allowed: {{formats}}',
        allowedFormats: 'JPG, JPEG, PNG, GIF, WEBP, MP3, MP4, MOV',
        uploadErrors: 'File upload errors:',
        filesUploadedSuccess: 'Successfully uploaded files: {{count}}',
      },
    },
    capsulePost: {
      dateNotSpecified: 'Date not specified',
      unknownAuthor: 'Unknown author',
      titleUnavailable: 'Title unavailable',
      contentUnavailable: 'Content unavailable',
      donate: 'Donate',
      plantTree: 'Plant tree',
      expand: 'more',
      collapse: 'collapse',
    },
    capsuleCreators: {
      you: 'You',
      youAndCoauthors: 'You and {count} {coauthor}',
      ownerAndCoauthors: '{owner} and {count} {coauthor}',
      coauthorsOnly: '{count} {coauthor}',
      coauthorOne: 'co-author',
      coauthorFew: 'co-authors',
      coauthorMany: 'co-authors',
    },
    capsulePostActions: {
      delete: 'Delete',
      copyLink: 'Copy link',
    },
    myCapsules: {
      title: 'My capsules',
      closed: 'Closed',
      opened: 'Opened',
      activate: 'Activate',
      noCapsules: 'No capsules yet',
      notifications: {
        activateSuccess: 'Capsule activated successfully',
        activateError: 'Failed to activate capsule',
        publishSuccess: 'Publish approval recorded',
        publishError: 'Failed to publish life capsule',
        createSuccess: 'Capsule created successfully',
        createError: 'Failed to save capsule',
        deleteSuccess: 'Capsule deleted',
      },
    },
    feed: {
      emptyCapsules: 'No capsules yet',
    },
    capsulesEmptyState: {
      createButton: 'Create capsule',
    },
    footer: {
      menuTitles: {
        menu: 'Menu',
        contacts: 'Contacts',
        weWillContactYou: 'We will contact you',
      },
      menuItems: {
        about: 'About',
        faq: 'FAQ',
        notifications: 'Notifications',
        profile: 'Profile',
        feed: 'Home (Feed)',
        myCapsules: 'My capsules',
      },
      interactiveMenuItems: {
        select: {
          wantToCollaborate: 'Want to collaborate',
          wantToBePartner: 'Want to be a partner',
          feedbackOrIdea: 'Feedback or idea',
          commercialProposal: 'Commercial proposal',
          mediaPublication: 'Media publication',
          other: 'Other',
        },
        input: {
          yourEmail: 'Your email',
        },
        button: {
          send: 'Send',
        },
      },
      links: {
        privacyPolicy: 'Privacy Policy',
        termsOfUse: 'Terms of Use',
      },
    },
    profileMenu: {
      metrics: {
        followers: 'followers',
        following: 'following',
        coauthors: 'co-authors',
      },
      tabs: {
        profile: 'Profile',
        security: 'Security',
        privacy: 'Privacy',
        notifications: 'Notifications',
        billing: 'Subscription',
        wallet: 'Wallet',
      },
      logout: 'Logout',
    },
    profileTab: {
      username: 'Username',
      usernamePlaceholder: 'Username',
      firstName: 'First name',
      middleName: 'Middle name',
      lastName: 'Last name',
      bio: 'Bio',
      personalInfo: 'Personal info',
      gender: 'Gender',
      genderNotSelected: 'Not selected',
      male: 'Male',
      female: 'Female',
      birthday: 'Birthday',
      datePlaceholder: 'DD.MM.YYYY',
      birthPlace: 'Birth place',
      residencePlace: 'Residence place',
      country: 'Country',
      city: 'City',
      postalCode: 'Postal code',
      socials: 'Socials',
      mediatorSummary: 'What the mediator knows about me',
      mediatorSummaryEmpty:
        'Nothing yet. The card appears after you write a few messages in a group chat.',
      cancelChanges: 'Discard changes',
    },
    profileSecurity: {
      phone: 'Phone number',
      email: 'Email',
      password: 'Password',
      change: 'Change',
      currentPassword: 'Current password',
      newPassword: 'New password',
      changePasswordTitle: 'Change password',
      changePasswordSuccess: 'Password changed successfully.',
      changePasswordError: 'Failed to change password.',
      changePasswordWrong: 'Current password is incorrect.',
      cancel: 'Cancel',
      save: 'Save',
    },
    profilePrivacy: {
      title: 'Show avatar and name in comments',
      all: 'All',
      coauthors: 'Co-authors only',
      selected: 'Selected people only',
      noSelectedUsers: 'You have no selected users yet',
      invite: 'Invite',
      emailDuplicatesEnabled: 'Allow duplicate email notifications',
    },
    profileNotifications: {
      title: 'Notifications',
      unread: 'Unread',
      read: 'Read',
      all: 'All',
      emptyUnread: 'You have no unread notifications left',
      emptyRead: 'You have no read notifications',
      emptyAll: 'You have no notifications yet',
      messages: {
        invite: '{inviterName} invites you to capsule «{capsuleName}»',
        custodian_invite:
          'You have been appointed keeper of capsule «{capsuleName}»',
        custodian_activated: 'Keeper activated capsule «{capsuleName}»',
        capsule_opened: 'Capsule «{capsuleName}» has been opened',
        coauthor_declined:
          '{declinerName} declined to be a co-author in capsule «{capsuleName}»',
        death_report:
          '{reporterName} requested to publish life capsule «{capsuleName}». If this is a mistake, cancel the request.',
        donation:
          '{donorName} donated {amount} $ for planting «{treeName}» for your capsule «{capsuleName}»',
        fundraising_started:
          'For your capsule «{capsuleName}», {initiatorName} started a fundraising campaign for planting «{treeName}»',
        fundraising_completed:
          'For your capsule «{capsuleName}», funds have been collected for planting «{treeName}»',
        reaction: '{reactorName} left a reaction in capsule «{capsuleName}»',
        invite_response_accepted:
          '{actorName} accepted the invitation to capsule «{capsuleName}»',
        invite_response_declined:
          '{actorName} declined the invitation to capsule «{capsuleName}»',
      },
      actions: {
        accept: 'Accept',
        decline: 'Decline',
        reinvite: 'Reinvite',
        read: 'Mark as read',
        cancel: 'Cancel',
        cancelDeathReport: 'Cancel request',
      },
      activatedAt: 'Activated: ',
      timeLeft: 'Time left:',
      countdownDaysShort: 'd',
      reinviteSuccess: 'Reinvite sent',
    },
    profileBilling: {
      title: 'PRO subscription',
      pricePromo: '100 $/mo',
      includes: 'What’s included',
      benefits: {
        unlimitedCapsules: 'Unlimited capsules',
        comments: 'Ability to leave comments',
        giftReactions: '5 paid reactions as a gift',
      },
      price: '200 $/mon',
      nextPaymentPrefix: 'Your next payment will be charged on',
      subscribe: 'Subscribe',
      unsubscribe: 'Unsubscribe',
    },
    socialInput: {
      placeholder: 'Paste a profile link',
    },
    userProfile: {
      filter: {
        author: 'Author',
        coauthor: 'Coauthor',
      },
      noCapsules: 'User has no capsules yet',
    },
    userProfileCard: {
      notSpecified: 'Not specified',
      copyId: 'Copy ID',
      metrics: {
        followers: 'followers',
        following: 'following',
        coauthors: 'coauthors',
      },
      follow: 'Follow',
      unfollow: 'Unfollow',
    },
    aboutPage: {
      section01: {
        text: 'We believe that life is beautiful, complex and fragile. TimeCaps brings together everything that helps people stay connected across time and distance.',
      },
      section02: {
        text1:
          'Knowing how important it is not to miss a moment, we have created simple, gentle tools for preserving your personal and family story.',
        text2:
          "# 1. Connection and support\n## Stay closer to the people you love, even when there is no time for an ordinary phone call.\nEvery one of us has people we wish we talked to more often: calling our parents or older relatives, asking a friend how their week went, speaking with someone who lives alone. But in the endless stream of work, chores and worries we keep postponing these conversations — not because they don't matter to us, but because it always seems like \"I'll call a bit later.\"\nOur project helps make conversation a regular and natural part of life.\nCreate a chat with one person or a small group — family, friends or acquaintances who especially need attention and real conversation. Our mediator will help the conversation begin and keep going: it will suggest an interesting topic, ask a question, support the discussion and gently draw in every participant.\nThe mediator can also keep the conversation going on its own — asking questions, listening to stories and simply being an attentive companion, even when you haven't managed to join in. For a lonely older person, even such a conversation can become a pleasant moment of the day — a chance to feel attention, interest in their life, and that someone is ready to listen.\nBecause sometimes a person needs very little: to be asked how they are, to have their story heard, and simply to be with someone in the same conversation.",
      },
      section03: {
        text: '# 2. Time capsule: a letter to a loved one\n## Save what matters most for the people who matter to you\nIn the daily rush we often lack the moment to say the warmest and most needed words to the most important people in our lives. A time capsule is a chance to carefully capture what has long lived in your heart: words of love, gratitude, appreciation or important memories.\nYou can share them today, or entrust the service to deliver your message on a chosen day in the future — when your loved ones will especially need to feel your support and warmth.',
        displayText:
          'These digital time capsules are not just files or posts. They are sincere letters, videos, photos, and thoughts — filled with love and preserved for the future.',
      },
      section04: {
        text: '# 3. Caring for the older generation\n## Help your family preserve their story\nEvery generation has its own wisdom, family stories and memories that are so important to keep. Help your parents, grandparents or older loved ones write down their thoughts and messages.\nWe made the process as simple and intuitive as possible: you can fill in their first "time capsule" together, ask about the things there was never time to ask, and teach them this gentle way of leaving a mark in the family\'s memory.',
      },
      section05: {
        text1:
          '# 4. Shared memory: collective memories\n## Share what matters in a common space\nEach of us has events and people that remain a spark in the soul. Share your feelings, stories and memories in our collective meditation.\nThis is a space of warmth and memory, where sincere stories bring people together, help them live through important emotions and feel that we are not alone.',
        text2:
          'We are here to help you preserve what truly matters. Share your feelings, emotions, experiences.',
        text3: 'Join us.',
      },
      section06: {
        title:
          "Let's celebrate life together, cherish the past, and leave behind something truly meaningful!",
        button: 'Create capsule',
      },
    },
    payment: {
      title: {
        treeDonation: 'Tree planting',
        subscription: 'Subscription checkout',
        scenarioPurchase: 'Scenario purchase',
      },
      card: {
        attachCard: 'Link your card',
      },
      cardInput: {
        numberPlaceholder: '0000 0000 0000 0000',
        namePlaceholder: 'NAME SURNAME',
        expiryPlaceholder: 'MM/YY',
        cvvPlaceholder: 'CVV',
      },
      subscribePlan: {
        choosePlan: 'Choose your plan',
        yearPlan: 'Yearly subscription',
        monthPlan: 'Monthly subscription',
        preliminaryTotal: 'Preliminary total',
        discount: 'Discount',
        total: 'Total',
        priceSuffix: '$/mo',
      },
      scenarioPurchase: {
        purchaseScenario: 'Purchase scenario',
      },
      actions: {
        agreePrefix: 'I agree with',
        terms: 'terms',
        brand: 'TimeCaps',
        pay: 'Pay',
        processing: 'Processing...',
      },
      operationInfo: {
        remaining: 'Remaining',
        requestId: 'Request ID',
      },
      treeDonate: {
        enterAmountTitle: 'Enter payment amount',
        rangeLabel: 'From 1,000 $ to 1,000,000 $',
        amountLabel: 'Payment amount',
      },
      wallet: {
        enterAmountTitle: 'Top up balance',
        rangeLabel: 'From 1 $',
        amountLabel: 'Top up amount',
        invalidAmount: 'Amount must be from 1 $',
        created: 'Payment created. Redirecting to checkout.',
        error: 'Error creating top-up',
      },
      progressBilling: {
        people: 'people',
        collected: 'Collected',
      },
    },
  },
  fr: {
    auth: {
      loginTitle: 'Bon retour !',
      registerTitle: 'Bienvenue !',
      login: 'Connexion',
      register: "S'inscrire",
      forgotPassword: 'Mot de passe oublié ?',
      email: 'Email',
      password: 'Mot de passe',
      name: 'Nom',
      confirmPassword: 'Confirmez le mot de passe',
      submit: 'Envoyer',
      backToLogin: 'Retour à la connexion',
      resetPassword: 'Réinitialiser le mot de passe',
      socialLogin: 'Se connecter avec',
      or: 'ou',
      noAccount: 'Pas de compte ?',
      haveAccount: 'Vous avez déjà un compte ?',
      createAccount: 'Créer un compte',
      switchLanguage: 'Changer de langue',
      newUser: 'Nouvel utilisateur ? Créer un',
      account: 'compte',
      or_continue_with: 'Ou continuer avec',
      terms_agreement: 'Vous acceptez les',
      terms_of_use: "conditions d'utilisation",
      and: 'et',
      privacy_policy: 'la politique de confidentialité',
      loginSuccess: 'Connexion réussie',
      registerSuccess: 'Inscription réussie',
      registerEmailSent:
        'Un lien de confirmation a été envoyé à votre email. Cliquez dessus, puis connectez-vous.',
      socialAuthSuccess: 'Connexion via réseau social réussie',
      verifyEmailTitle: 'Vérification de l’email',
      verifyEmailSuccess: 'Email vérifié. Vous pouvez vous connecter.',
      verifyEmailError: 'Lien invalide ou expiré.',
      verifyEmailNoToken: 'Lien de vérification non fourni.',
      resendVerification: 'Renvoyer l’email de vérification',
      resendVerificationSuccess: 'Si le compte existe, un email a été envoyé.',
      emailNotVerified: "Email non vérifié. Renvoyer l'email de vérification ?",
      resendVerificationSent: 'Email envoyé. Vérifiez votre boîte mail.',
      forgotPasswordTitle: 'Réinitialiser le mot de passe',
      forgotPasswordHint:
        'Entrez votre email pour recevoir un lien de réinitialisation.',
      forgotPasswordSuccess: 'Si le compte existe, un lien a été envoyé.',
      newPasswordLabel: 'Nouveau mot de passe',
      resetPasswordTitle: 'Nouveau mot de passe',
      resetPasswordSuccess:
        'Mot de passe mis à jour. Connectez-vous avec le nouveau.',
      resetPasswordError: 'Lien invalide ou expiré.',
      resetPasswordNoToken: 'Lien de réinitialisation non fourni.',
    },
    pages: {
      tree: {
        selectTree: 'Choisir un arbre',
      },
      faq: {
        blocks: {
          capsules: {
            title: 'À propos des capsules',
            items: {
              q1: "Qu'est-ce qu'une capsule temporelle et pourquoi en créer une ?",
              a1: 'Une capsule temporelle est un message, un souvenir ou une émotion enregistré numériquement pour être « ouvert » dans le futur.',
              q2: "Comment fonctionne l'envoi vers le futur ?",
              a2: 'Vous créez un message, choisissez la date et le destinataire ; nous le stockons et le livrons au bon moment.',
              q3: 'Puis-je inviter des co-auteurs ?',
              a3: 'Oui, invitez vos amis, votre famille ou vos collègues à créer une capsule ensemble.',
              q4: "Qu'est-ce qu'un « Événement » et comment le créer ?",
              a4: 'Un Événement est un moment à partager avec ses proches. Créez-le, invitez des co-auteurs et partagez ensemble pensées et sentiments.',
              q5: 'Que deviennent les capsules après mon décès ?',
              a5: 'Vous pouvez préparer une capsule à ouvrir après votre décès ou à une date précise. Nous la livrerons selon vos instructions.',
              q6: "Comment honorer la mémoire d'un défunt ?",
              a6: 'Créez une capsule mémorielle avec des histoires, photos et vidéos. Vous pouvez aussi planter un arbre comme hommage vivant.',
            },
          },
          trees: {
            title: 'À propos des arbres',
            items: {
              q1: 'Puis-je planter un arbre pour un événement ou une personne ?',
              a1: 'Oui. Nous collaborons avec des projets écologiques pour planter des arbres, en fournissant un certificat et une localisation sur la carte.',
              q2: 'Pourquoi planter un arbre ?',
              a2: "Cela relie la mémoire au futur : les arbres améliorent l'écologie et deviennent un symbole vivant.",
            },
          },
          other: {
            title: 'Autre',
            items: {
              q1: 'Le stockage des messages est-il sécurisé ?',
              a1: 'Nous utilisons le chiffrement et des sauvegardes pour garantir la confidentialité et la durabilité.',
              q2: 'Comment commencer ?',
              a2: "Inscrivez-vous, choisissez un type de capsule ou d'événement et suivez les étapes de configuration.",
            },
          },
        },
      },
    },
    capsuleCreation: {
      activation: {
        title: "Paramètres d'activation",
        manual: 'Déclenchement manuel',
        scheduled: 'À une date précise',
        custodian: 'Sur instruction du dépositaire de confiance',
        activate: 'Activer',
        selectDate: 'Choisir une date',
        selectedDate: '{{date}}',
        inviteCustodian: 'Inviter',
        noCustodians: 'Aucune personne de confiance',
        remove: 'Supprimer',
      },
      repeat: {
        title: 'Fréquence de répétition',
        countLabel: 'Nombre de répétitions',
        intervalLabel: 'Intervalle',
        infinite: 'Infini',
        popupTitle: "Configurer l'intervalle",
        apply: 'Appliquer',
        intervals: {
          year: 'Année',
          month: 'Mois',
          custom: 'Personnalisé',
        },
      },
    },
    capsuleReactions: {
      addReaction: 'Ajouter une réaction',
      dragAndDrop: 'Glisser-déposer',
      commentObjectAlt: 'Objet du commentaire',
      reactionsTitle: 'Méditation',
      emptyState: 'Pas encore de réactions',
      reactionAvatarAlt: "Avatar de l'auteur de la réaction",
      backgroundAlt: 'Arrière-plan du scénario',
      reactionAlt: 'Aperçu de la réaction',
      selectReaction: 'Sélectionnez une réaction pour voir le commentaire',
      commentLabel: 'Commentaire',
      closeComment: 'Fermer',
      back: 'Retour',
      replyLabel: 'Réponse',
      reply: 'Répondre',
      replyAction: 'Envoyer la réponse',
      noCommentYet: 'Pas encore de commentaire',
      dropHint: "Déposez l'objet sur la scène",
      anonymous: 'Anonyme',
      commentPlaceholder: 'Écrire un commentaire...',
      replyPlaceholder: 'Écrire une réponse...',
      create: 'Créer',
      changeStone: 'Changer de pierre',
      pressToChangeStone: 'Cliquez pour changer',
      selectStoneLabel: 'Choisissez une pierre',
      selectedStoneAlt: 'Pierre sélectionnée',
      freeStone: 'Gratuit',
      balanceLabel: 'Solde',
      purchaseStoneSuccess: 'Pierre achetée',
      purchaseStoneError: "Impossible d'acheter la pierre",
      purchaseConfirmText:
        'Êtes-vous sûr de vouloir acheter la pierre "{{name}}" pour "{{price}}" ?',
      purchaseConfirm: 'Confirmer',
      purchaseCancel: 'Annuler',
    },
    capsuleScenarios: {
      freeLabel: 'Gratuit',
      previewAlt: 'Aperçu du scénario :',
      commentObjectAlt: 'Objet du commentaire du scénario :',
      status: {
        available: 'Disponible',
        locked: 'Scénario Premium',
      },
      lockedPopup: {
        title: 'Scénario Premium',
        description: 'Ce scénario ne vous est pas encore accessible',
        pricePrefix: 'Prix :',
        priceSuffix: '$',
        buy: "Acheter l'accès",
        close: 'Peut-être plus tard',
        reactions: {
          balloon: 'Réactions : envol de ballons',
          candle: 'Réactions : bougies allumées',
          flashlight: 'Réactions : lueurs nocturnes',
        },
      },
      balloon: {
        title: 'Ballons',
        description:
          'Une fête romantique en plein air. Lumières, ballons et légèreté.',
        previewComment: {
          author: 'Maria',
          text: "J'adore ce moment !",
          date: '16.01, 15:00',
        },
      },
      candle: {
        title: 'Bougies',
        description:
          'Une soirée chaleureuse entre amis. Douce lueur et histoires au coin du feu.',
        previewComment: {
          author: 'Anna',
          text: 'Les bougies rendent chaque soirée spéciale.',
          date: '03.12, 19:02',
        },
      },
      flashlight: {
        title: 'Lanternes',
        description:
          'Les lumières chaudes de la ville la nuit. Parfait pour des aveux éclatants et des improvisations.',
        previewComment: {
          author: 'Alexey',
          text: 'La promenade la plus magique sous les lumières de la ville.',
          date: '12.09, 22:48',
        },
      },
      pebble: {
        title: 'Galets de mer',
        description:
          'Le bruit des vagues et des pas sur le sable. Idéal pour les souvenirs de voyage.',
        previewComment: {
          author: 'Katherine',
          text: 'Tu te souviens quand on ramassait des galets au coucher du soleil ?',
          date: '21.06, 20:15',
        },
      },
    },
    inviteCoauthors: {
      title: 'Définir le cercle de personnes de confiance',
      custodianHint:
        'Vous ne pouvez inviter un gardien de confiance que si vous vous suivez mutuellement',
      searchPlaceholder: 'Entrez un nom ou email',
      searchMatches: 'Résultats pour votre recherche',
      emailPlaceholder: 'Email',
      sendInvite: "Envoyer l'invitation",
      invite: 'Inviter',
      noResults: 'Aucun résultat trouvé',
      hint: 'Commencez à taper pour voir des suggestions',
      copyLink: 'Copier le lien',
      error:
        "Impossible d'envoyer l'invitation. Vérifiez les données et réessayez.",
    },
    activationPopup: {
      title: 'Activation',
      dateTitle: 'Choisir la date',
      timeTitle: "Choisir l'heure",
      dateTab: 'Date',
      timeTab: 'Heure',
      apply: 'Appliquer',
    },
    validation: {
      emailRequired: "L'email est requis",
      emailInvalid: 'Veuillez entrer un email valide',
      passwordRequired: 'Le mot de passe est requis',
      passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      confirmPasswordRequired: 'Veuillez confirmer votre mot de passe',
    },
    errors: {
      invalidCredentials: 'Email ou mot de passe invalide',
      userNotFound: 'Utilisateur introuvable',
      emailAlreadyExists: 'Un utilisateur avec cet email existe déjà',
      networkError: 'Erreur réseau. Veuillez réessayer plus tard',
      unknownError: 'Une erreur inconnue est survenue',
    },
    common: {
      pageNotFound: 'Page non trouvée',
      loading: 'Chargement...',
      content: 'Contenu',
      reactions: 'Méditation',
      close: 'Fermer',
      save: 'Enregistrer',
      cancel: 'Annuler',
      back: 'Retour',
      more: 'Plus',
      collapse: 'Réduire',
      timeUnits: {
        years: 'Années',
        months: 'Mois',
        days: 'Jours',
        hours: 'Heures',
        minutes: 'Minutes',
      },
      timeCounter: {
        increase: 'Augmenter',
        decrease: 'Diminuer',
      },
    },
    chat: {
      page: {
        selectConversation: 'Choisissez une discussion ou commencez-en une',
      },
      list: {
        title: 'Discussions',
        searchPlaceholder: 'Rechercher une discussion',
        loading: 'Chargement des discussions...',
        empty: 'Aucune discussion pour le moment',
        nothingFound: 'Aucun résultat',
        noMessages: 'Aucun message',
        untitled: 'Sans titre',
        capsuleAttachment: 'Capsule',
        ownPrefix: 'Vous : {text}',
      },
      thread: {
        loading: 'Chargement de la conversation...',
        empty: 'Aucun message. Lancez la conversation !',
        today: "Aujourd'hui",
        yesterday: 'Hier',
      },
      composer: {
        placeholder: 'Écrivez un message, « / » pour joindre une capsule',
        capsuleHint: 'Vos capsules',
        searching: 'Recherche de capsules...',
        noCapsules: 'Aucune capsule trouvée',
        removeAttachment: 'Retirer la capsule',
      },
      message: {
        capsuleUnavailable: 'Capsule indisponible',
        sending: 'Envoi...',
        retry: 'Non envoyé. Réessayer',
      },
      new: {
        title: 'Nouvelle discussion',
        groupTitle: 'Nouveau groupe',
        tabDirect: 'Discussion privée',
        tabGroup: 'Groupe',
        searchPlaceholder: "Nom d'utilisateur",
        searchHint: "Trouvez quelqu'un par son nom d'utilisateur",
        searching: 'Recherche...',
        nothingFound: 'Aucun utilisateur trouvé',
        groupNamePlaceholder: 'Nom du groupe',
        createGroup: 'Créer le groupe',
      },
      details: {
        title: 'Infos sur la discussion',
        members: 'Membres',
        membersSuffix: 'membres',
        addMembers: 'Ajouter des membres',
        inviteLink: "Lien d'invitation",
        inviteLinkHint: 'Appuyez sur « Copier » pour obtenir le lien',
        copyLink: 'Copier',
        linkCopied: 'Copié',
        removeMember: 'Retirer le membre',
        leaveGroup: 'Quitter le groupe',
        openProfile: 'Ouvrir le profil',
        role: {
          owner: 'Créateur',
          admin: 'Admin',
        },
      },
      invite: {
        loading: "Chargement de l'invitation...",
        invalid: "Ce lien d'invitation n'est plus valide",
        join: 'Rejoindre la discussion',
        open: 'Ouvrir la discussion',
        invitedBy: 'invité par',
      },
      system: {
        someone: "Quelqu'un",
        groupCreated: '{actor} a créé le groupe « {title} »',
        membersAdded: '{actor} a ajouté {users}',
        memberJoined: '{actor} a rejoint via le lien',
        memberRemoved: '{actor} a retiré {users}',
        memberLeft: '{actor} a quitté la discussion',
        groupRenamed: '{actor} a renommé la discussion en « {to} »',
      },
      mediator: {
        name: 'Médiateur',
        sectionTitle: 'Médiateur',
        sectionHint:
          'Aide à garder le lien : invite dans les discussions, rappelle les dates, prend des nouvelles.',
        on: 'Activé',
        off: 'Désactivé',
        toggleError: 'Impossible de modifier le réglage du médiateur',
      },
      errors: {
        conversationsLoad: 'Impossible de charger les discussions',
        messagesLoad: 'Impossible de charger les messages',
        conversationCreate: 'Impossible de créer la discussion',
        memberAdd: "Impossible d'ajouter le membre",
        memberRemove: 'Impossible de retirer le membre',
        inviteLink: "Impossible d'obtenir le lien",
      },
    },
    header: {
      home: 'Accueil',
      about: 'À propos',
      faq: 'FAQ',
      capsules: 'Capsules',
      chat: 'Discussions',
      notifications: 'Notifications',
      profile: 'Profil',
      create: 'Créer',
      search: 'Rechercher dans vos capsules...',
      toMyCapsules: 'Mes capsules',
      growTree: 'Planter un arbre',
      preview: 'Aperçu',
      exitPreview: "Quitter l'aperçu",
      activateCapsule: 'Activer la capsule',
      upload: 'Télécharger',
      created: 'Créée le',
      firstOpened: 'Ouverte le',
      selectTree: 'Choisir un arbre',
      menu: 'Menu',
      searchUsers: 'Utilisateurs',
      searchCapsules: 'Capsules',
      searchLoading: 'Recherche...',
      searchEmpty: 'Aucun résultat',
    },
    capsuleCreate: {
      tabs: {
        settings: 'Étape 1 →',
        content: 'Étape 2 →',
        scenarios: 'Étape 3',
      },
      titleLabel: 'Titre de la capsule',
      descriptionLabel: 'Qu’aimeriez-vous partager aujourd’hui?',
      draftTitle: 'Sans titre',
      authorName: 'Vous',
      coauthors: {
        title: 'Co-auteurs',
        noCoauthors: "Vous n'avez pas encore de co-auteurs",
        invite: 'Inviter',
        loading: 'Chargement...',
        reinvite: 'Renvoyer',
        remove: 'Supprimer',
        status: {
          pending: 'Envoyé',
          accepted: 'Accepté',
          declined: 'Refusé',
        },
      },
      viewers: {
        title: 'Qui peut voir la capsule ?',
        all: 'Tout le monde',
        coauthors: 'Seulement les co-auteurs',
        selected: 'Seulement les personnes sélectionnées',
        invite: 'Choisir',
      },
      contentEmpty: "Vous n'avez pas encore de contenu, téléchargez-le",
      contentUpload: {
        title: 'Téléchargez vos fichiers médias',
        cancel: 'Annuler',
        clearAll: 'Tout effacer',
        save: 'Enregistrer',
        backToUpload: 'Retour au téléchargement',
        viewMedia: 'Voir le média',
        description: 'Description',
        deleteDescription: 'Supprimer la description',
        replaceMedia: 'Remplacer le média',
        filePreview: 'Aperçu du fichier',
        videoPreview: 'Aperçu vidéo',
        gifPreview: 'Aperçu GIF',
        maxFilesReached: 'Maximum de fichiers : {{max}}. Limite atteinte.',
        maxFilesPartial:
          'Maximum de fichiers : {{max}}. Seulement {{loaded}} sur {{total}} fichiers téléchargés.',
        video: 'VIDÉO',
        gif: 'GIF',
        dragAndDrop: 'Téléchargez ou glissez-déposez des fichiers',
        fileFormats: 'JPG, JPEG, PNG, GIF, MP3, MP4, MOV, WEBP. Max 20 Mo',
        livePhotoNote:
          "Les Live Photos d'iPhone seront automatiquement converties en GIF",
        fileTooLarge:
          'Le fichier "{{fileName}}" est trop volumineux ({{size}} Mo). Taille maximale : {{maxSize}} Mo',
        unsupportedFormat:
          'Le fichier "{{fileName}}" a un format non supporté. Autorisés : {{formats}}',
        allowedFormats: 'JPG, JPEG, PNG, GIF, WEBP, MP3, MP4, MOV',
        uploadErrors: 'Erreurs de téléchargement :',
        filesUploadedSuccess: 'Fichiers téléchargés avec succès : {{count}}',
      },
    },
    capsulePost: {
      dateNotSpecified: 'Date non spécifiée',
      unknownAuthor: 'Auteur inconnu',
      titleUnavailable: 'Titre indisponible',
      contentUnavailable: 'Contenu indisponible',
      donate: 'Contribuer',
      plantTree: 'Planter un arbre',
      expand: 'plus',
      collapse: 'réduire',
    },
    capsuleCreators: {
      you: 'Vous',
      youAndCoauthors: 'Vous et {count} {coauthor}',
      ownerAndCoauthors: '{owner} et {count} {coauthor}',
      coauthorsOnly: '{count} {coauthor}',
      coauthorOne: 'co-auteur',
      coauthorFew: 'co-auteurs',
      coauthorMany: 'co-auteurs',
    },
    capsulePostActions: {
      delete: 'Supprimer',
      copyLink: 'Copier le lien',
    },
    myCapsules: {
      title: 'Mes capsules',
      closed: 'Fermées',
      opened: 'Ouvertes',
      activate: 'Activer',
      noCapsules: 'Pas encore de capsules',
      notifications: {
        activateSuccess: 'Capsule activée avec succès',
        activateError: "Échec de l'activation de la capsule",
        publishSuccess: 'Approbation de publication enregistrée',
        publishError: 'Échec de la publication de la capsule de vie',
        createSuccess: 'Capsule créée avec succès',
        createError: "Échec de l'enregistrement de la capsule",
        deleteSuccess: 'Capsule supprimée',
      },
    },
    feed: {
      emptyCapsules: 'Pas encore de capsules',
    },
    capsulesEmptyState: {
      createButton: 'Créer une capsule',
    },
    footer: {
      menuTitles: {
        menu: 'Menu',
        contacts: 'Contacts',
        weWillContactYou: 'Nous vous contacterons',
      },
      menuItems: {
        about: 'À propos',
        faq: 'FAQ',
        notifications: 'Notifications',
        profile: 'Profil',
        feed: 'Accueil (Fil)',
        myCapsules: 'Mes capsules',
      },
      interactiveMenuItems: {
        select: {
          wantToCollaborate: 'Je veux collaborer',
          wantToBePartner: 'Je veux devenir partenaire',
          feedbackOrIdea: 'Avis ou idée',
          commercialProposal: 'Proposition commerciale',
          mediaPublication: 'Publication média',
          other: 'Autre',
        },
        input: {
          yourEmail: 'Votre email',
        },
        button: {
          send: 'Envoyer',
        },
      },
      links: {
        privacyPolicy: 'Politique de confidentialité',
        termsOfUse: "Conditions d'utilisation",
      },
    },
    profileMenu: {
      metrics: {
        followers: 'abonnés',
        following: 'abonnements',
        coauthors: 'co-auteurs',
      },
      tabs: {
        profile: 'Profil',
        security: 'Sécurité',
        privacy: 'Confidentialité',
        notifications: 'Notifications',
        billing: 'Abonnement',
        wallet: 'Portefeuille',
      },
      logout: 'Déconnexion',
    },
    profileTab: {
      username: "Nom d'utilisateur",
      usernamePlaceholder: "Nom d'utilisateur",
      firstName: 'Prénom',
      middleName: 'Deuxième prénom',
      lastName: 'Nom',
      bio: 'Bio',
      personalInfo: 'Informations personnelles',
      gender: 'Genre',
      genderNotSelected: 'Non sélectionné',
      male: 'Homme',
      female: 'Femme',
      birthday: 'Date de naissance',
      datePlaceholder: 'JJ.MM.AAAA',
      birthPlace: 'Lieu de naissance',
      residencePlace: 'Lieu de résidence',
      country: 'Pays',
      city: 'Ville',
      postalCode: 'Code postal',
      socials: 'Réseaux sociaux',
      mediatorSummary: 'Ce que le médiateur sait de moi',
      mediatorSummaryEmpty:
        'Rien pour l’instant. La fiche apparaît après quelques messages dans une discussion de groupe.',
      cancelChanges: 'Annuler les modifications',
    },
    profileSecurity: {
      phone: 'Numéro de téléphone',
      email: 'Email',
      password: 'Mot de passe',
      change: 'Modifier',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      changePasswordTitle: 'Changer le mot de passe',
      changePasswordSuccess: 'Mot de passe modifié avec succès.',
      changePasswordError: 'Impossible de modifier le mot de passe.',
      changePasswordWrong: 'Le mot de passe actuel est incorrect.',
      cancel: 'Annuler',
      save: 'Enregistrer',
    },
    profilePrivacy: {
      title: "Afficher l'avatar et le nom dans les commentaires",
      all: 'Tout le monde',
      coauthors: 'Co-auteurs uniquement',
      selected: 'Personnes sélectionnées uniquement',
      noSelectedUsers: "Vous n'avez pas encore d'utilisateurs sélectionnés",
      invite: 'Inviter',
      emailDuplicatesEnabled: 'Autoriser les notifications email en double',
    },
    profileNotifications: {
      title: 'Notifications',
      unread: 'Non lues',
      read: 'Lues',
      all: 'Toutes',
      emptyUnread: "Vous n'avez plus de notifications non lues",
      emptyRead: "Vous n'avez aucune notification lue",
      emptyAll: "Vous n'avez pas encore de notifications",
      messages: {
        invite: '{inviterName} vous invite à la capsule « {capsuleName} »',
        custodian_invite:
          'Vous avez été nommé gardien de la capsule « {capsuleName} »',
        custodian_activated: 'Le gardien a activé la capsule « {capsuleName} »',
        capsule_opened: "La capsule « {capsuleName} » s'est ouverte",
        coauthor_declined:
          "{declinerName} a refusé d'être co-auteur de la capsule « {capsuleName} »",
        death_report:
          "{reporterName} a demandé la publication de la capsule de vie « {capsuleName} ». Si c'est une erreur, annulez la demande.",
        donation:
          '{donorName} a fait un don de {amount} $ pour la plantation de « {treeName} » pour votre capsule « {capsuleName} »',
        fundraising_started:
          'Pour votre capsule « {capsuleName} », {initiatorName} a lancé une collecte de fonds pour planter « {treeName} »',
        fundraising_completed:
          'Pour votre capsule « {capsuleName} », les fonds ont été récoltés pour planter « {treeName} »',
        reaction:
          '{reactorName} a laissé une réaction dans la capsule « {capsuleName} »',
        invite_response_accepted:
          '{actorName} a accepté l’invitation à la capsule « {capsuleName} »',
        invite_response_declined:
          '{actorName} a refusé l’invitation à la capsule « {capsuleName} »',
      },
      actions: {
        accept: 'Accepter',
        decline: 'Refuser',
        reinvite: 'Réinviter',
        read: 'Marquer comme lu',
        cancel: 'Annuler',
        cancelDeathReport: 'Annuler la demande',
      },
      activatedAt: 'Activée : ',
      timeLeft: 'Temps restant :',
      countdownDaysShort: 'j',
      reinviteSuccess: 'Réinvitation envoyée',
    },
    profileBilling: {
      title: 'Abonnement PRO',
      pricePromo: '100 $/mois',
      includes: 'Ce qui est inclus',
      benefits: {
        unlimitedCapsules: 'Capsules illimitées',
        comments: 'Possibilité de laisser des commentaires',
        giftReactions: '5 réactions payantes offertes',
      },
      price: '200 $/mois',
      nextPaymentPrefix: 'Votre prochain paiement sera débité le',
      subscribe: "S'abonner",
      unsubscribe: 'Se désabonner',
    },
    socialInput: {
      placeholder: 'Collez un lien de profil',
    },
    userProfile: {
      filter: {
        author: 'Auteur',
        coauthor: 'Co-auteur',
      },
      noCapsules: "L'utilisateur n'a pas encore de capsules",
    },
    userProfileCard: {
      notSpecified: 'Non spécifié',
      copyId: "Copier l'ID",
      metrics: {
        followers: 'abonnés',
        following: 'abonnements',
        coauthors: 'co-auteurs',
      },
      follow: "S'abonner",
      unfollow: 'Se désabonner',
    },
    aboutPage: {
      section01: {
        text: 'Nous croyons que la vie est belle, complexe et fragile. TimeCaps rassemble tout ce qui aide à rester en lien à travers le temps et la distance.',
      },
      section02: {
        text1:
          "Conscients de l'importance de ne pas laisser passer un moment, nous avons créé des outils simples et bienveillants pour préserver votre histoire personnelle et familiale.",
        text2:
          "# 1. Échange et soutien\n## Restez proche de ceux qui vous sont chers, même quand le temps manque pour un simple appel.\nChacun de nous a des personnes avec qui il aimerait parler plus souvent : appeler ses parents ou ses proches âgés, demander à un ami comment s'est passée sa semaine, discuter avec quelqu'un qui vit seul. Mais dans le flot incessant du travail, des tâches et des soucis, nous repoussons souvent ces conversations — non pas parce qu'elles comptent peu pour nous, mais parce qu'il nous semble toujours que « j'appellerai un peu plus tard ».\nNotre projet aide à faire de l'échange une partie régulière et naturelle de la vie.\nCréez une discussion avec une personne ou un petit groupe — famille, amis ou connaissances pour qui l'attention et la conversation vivante comptent particulièrement. Notre médiateur aide la conversation à démarrer et à se poursuivre : il propose un sujet intéressant, pose une question, soutient l'échange et invite doucement chaque participant à s'y joindre.\nLe médiateur peut aussi entretenir la conversation de lui-même : poser des questions, écouter des histoires et être simplement un interlocuteur attentif, même si vous n'avez pas pu vous joindre à la discussion. Pour une personne âgée seule, un tel échange peut devenir un moment agréable de la journée — l'occasion de sentir l'attention, l'intérêt porté à sa vie et la présence de quelqu'un prêt à l'écouter.\nCar parfois, une personne a besoin de très peu : qu'on lui demande comment elle va, qu'on écoute son histoire et qu'on soit simplement avec elle dans la même conversation.",
      },
      section03: {
        text: "# 2. Capsule temporelle : une lettre à un proche\n## Gardez l'essentiel pour ceux qui vous sont chers\nDans l'agitation quotidienne, nous manquons souvent de temps pour dire les mots les plus chaleureux et les plus nécessaires aux personnes les plus importantes de notre vie. La capsule temporelle permet de consigner avec soin ce qui vit depuis longtemps dans votre cœur : des mots d'amour, de gratitude, de reconnaissance ou des souvenirs importants.\nVous pouvez les partager dès aujourd'hui, ou confier au service le soin de transmettre votre message à une date précise dans l'avenir — quand vos proches auront particulièrement besoin de sentir votre soutien et votre tendresse.",
        displayText:
          "Ces capsules temporelles numériques ne sont pas de simples fichiers ou publications. Ce sont des lettres sincères, des vidéos, des photos et des pensées — remplies d'amour et préservées pour l'avenir.",
      },
      section04: {
        text: "# 3. Prendre soin de la génération des aînés\n## Aidez vos proches à préserver leur histoire\nChaque génération a sa propre sagesse, ses histoires de famille et ses souvenirs, qu'il est si important de conserver. Aidez vos parents, grands-parents ou proches plus âgés à mettre par écrit leurs pensées et leurs messages.\nNous avons rendu le processus aussi simple et intuitif que possible : vous pouvez remplir ensemble leur première « capsule temporelle », les interroger sur ce dont il n'y avait jamais le temps de parler, et leur apprendre cette belle façon de laisser une trace dans la mémoire de la famille.",
      },
      section05: {
        text1:
          "# 4. Mémoire commune : souvenirs collectifs\n## Partagez l'essentiel dans un espace commun\nChacun de nous garde des événements et des personnes comme une étincelle dans l'âme. Partagez vos sentiments, vos histoires et vos souvenirs dans notre méditation collective.\nC'est un espace de chaleur et de mémoire, où des histoires sincères rapprochent les gens, aident à traverser des émotions importantes et à sentir que nous ne sommes pas seuls.",
        text2:
          'Nous sommes là pour vous aider à préserver ce qui compte vraiment. Partagez vos sentiments, vos émotions, vos expériences.',
        text3: 'Rejoignez-nous.',
      },
      section06: {
        title:
          'Célébrons la vie ensemble, chérissons le passé et laissons derrière nous quelque chose de vraiment significatif !',
        button: 'Créer une capsule',
      },
    },
    payment: {
      title: {
        treeDonation: "Plantation d'arbre",
        subscription: "Paiement de l'abonnement",
        scenarioPurchase: 'Achat de scénario',
      },
      card: {
        attachCard: 'Lier votre carte',
      },
      cardInput: {
        numberPlaceholder: '0000 0000 0000 0000',
        namePlaceholder: 'PRÉNOM NOM',
        expiryPlaceholder: 'MM/AA',
        cvvPlaceholder: 'CVV',
      },
      subscribePlan: {
        choosePlan: 'Choisissez votre forfait',
        yearPlan: 'Abonnement annuel',
        monthPlan: 'Abonnement mensuel',
        preliminaryTotal: 'Total provisoire',
        discount: 'Réduction',
        total: 'Total',
        priceSuffix: '$/mois',
      },
      scenarioPurchase: {
        purchaseScenario: 'Acheter le scénario',
      },
      actions: {
        agreePrefix: "J'accepte les",
        terms: 'conditions',
        brand: 'TimeCaps',
        pay: 'Payer',
        processing: 'Traitement...',
      },
      operationInfo: {
        remaining: 'Restant',
        requestId: 'ID de demande',
      },
      treeDonate: {
        enterAmountTitle: 'Entrez le montant du paiement',
        rangeLabel: 'De 1 $',
        amountLabel: 'Montant du paiement',
      },
      wallet: {
        enterAmountTitle: 'Recharger le solde',
        rangeLabel: 'De 1 $',
        amountLabel: 'Montant de la recharge',
        invalidAmount: 'Le montant doit être compris entre 1 $',
        created: 'Paiement créé. Redirection vers le paiement.',
        error: 'Erreur lors de la création de la recharge',
      },
      progressBilling: {
        people: 'personnes',
        collected: 'Collecté',
      },
    },
  },
};

export const getTranslation = (language: Language, key: string): string => {
  const keys = key.split('.');
  let value: any = translations[language];

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return key;
    }
  }

  return typeof value === 'string' ? value : key;
};
